import { z } from "zod";

import { calculateMinMonthlyDate } from "@/utils/date.ts";
const today = new Date();

export const auditDate = z
  .date()
  .max(
    new Date(today.setHours(today.getHours() + 12)),
    "Future date is not allowed",
  );
export const monthlyAuditDate = auditDate.min(
  calculateMinMonthlyDate(new Date()),
  "Date is outside of submission window",
);
